import httpService from './httpService';

export function fetchPersonalLinkConnectionStatus(linkId: string): Promise<any> {
  return httpService.get<any>(`/personal-links/${linkId}/connected`).then(({ data }): any => data);
}

/**
 * Use someone's personal link to invite them to
 * connect in the application
 *
 * @param linkId the id of the link to use
 * @param sharedProps the props to share with the invite
 */
export async function usePersonalLink(linkId: string, sharedProps: number[]): Promise<void> {
  await httpService.post<void>(`/personal-links/${linkId}/use`, { propertyIds: sharedProps });
}

/**
 * Accept an invite made through your personal link
 *
 * @param inviteId the id of the invite
 * @param sharedProps the props to share when accepting the invite
 */
export async function acceptPersonalInvite(linkId: string, sharedProps: number[]): Promise<void> {
  await httpService.post<void>(`/personal-invites/${linkId}/use`, { accept: true, sharedProperties: sharedProps });
}
